import { Elevations as PaperElevations } from '@/components/Paper/Paper.constants'

export const GROUP_NAME = 'popover'

export const DEFAULT_ELEVATION = PaperElevations.Elevated
